import { z } from 'zod';
import {
  BaseResponseSchema,
} from './primitives.js';

// ========================================
// Provider Ops — Unattested Device Dashboard
// ========================================

export const UnattestedAttemptStatusSchema = z.enum(['open', 'acknowledged', 'resolved']);


export const UnattestedAttemptSchema = z.object({
  attemptId: z.string(),
  tenantId: z.string(),
  siteId: z.string().nullable().optional(),
  deviceType: z.string().nullable().optional(),
  observedIdentifiers: z.object({
    serialNumber: z.string().nullable().optional(),
    macAddress: z.string().nullable().optional(),
    deviceId: z.string().nullable().optional(),
  }).nullable().optional(),
  sourceGatewaySerialNumber: z.string().nullable().optional(),
  sourceChannel: z.string().nullable().optional(),
  reasonCode: z.string().nullable().optional(),
  reasonDetail: z.string().nullable().optional(),
  firstSeenAt: z.string(),
  lastSeenAt: z.string(),
  attemptCount: z.number().int().min(1),
  status: UnattestedAttemptStatusSchema,
});


export const UnattestedAttemptListQuerySchema = z.object({
  tenantId: z.string().optional(),
  siteId: z.string().optional(),
  deviceType: z.string().optional(),
  status: UnattestedAttemptStatusSchema.optional(),
  fromDate: z.string().optional(),
  toDate: z.string().optional(),
  identifier: z.string().max(100).optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});


export const UnattestedAttemptListResponseSchema = BaseResponseSchema.extend({
  data: z.object({
    attempts: z.array(UnattestedAttemptSchema),
    nextCursor: z.string().nullable().optional(),
    count: z.number().int().min(0),
  }),
});


export const UnattestedAttemptDetailResponseSchema = BaseResponseSchema.extend({
  data: z.object({
    attempt: UnattestedAttemptSchema,
  }),
});
// Inferred types
export type UnattestedAttempt = z.infer<typeof UnattestedAttemptSchema>;
export type UnattestedAttemptDetailResponse = z.infer<typeof UnattestedAttemptDetailResponseSchema>;
export type UnattestedAttemptListQuery = z.infer<typeof UnattestedAttemptListQuerySchema>;
export type UnattestedAttemptListResponse = z.infer<typeof UnattestedAttemptListResponseSchema>;
export type UnattestedAttemptStatus = z.infer<typeof UnattestedAttemptStatusSchema>;
